import { getStoreResource } from '@/utils';
import React from 'react';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'holiday'];
const HOURS = Array.from({ length: 24 }, (_, i) => i);
const QUARTERS = [0, 1, 2, 3];

export function ReadOnlySchedule({ alarm = {} }) {
    const unit = getStoreResource('indicators', alarm.indicator_id)?.unit;

    const
        maxValue = unit === 'Wh' ? alarm.max_value / 1000 : alarm.max_value,
        minValue = unit === 'Wh' ? alarm.min_value / 1000 : alarm.min_value,
        schedule = alarm.schedule || {};

    return (
        <div className="tw-flex tw-flex-col tw-w-full tw-bg-white tw-text-gray-700">

            {/* Header: Days */}
            <div className="tw-flex tw-flex-none tw-bg-background-grey">
                <div className="tw-w-12 tw-flex-shrink-0 tw-p-1 tw-text-[10px] tw-font-bold tw-flex tw-items-center tw-justify-center">
                    HR
                </div>
                <div className="tw-flex tw-flex-grow">
                    {DAYS.map(day => (
                        <div
                            className={`tw-border tw-border-solid tw-border-border tw-flex-1 tw-text-center tw-py-1 tw-text-[10px] tw-font-bold tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis`}
                            key={day}
                        >
                            {i18next.t(`weekdays.${day}`)}
                            <div className="tw-flex tw-mt-0.5 tw-font-normal tw-text-[8px] tw-text-gray-400">
                                {QUARTERS.map(q => <div className="tw-flex-1" key={q}>{q}</div>)}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="tw-flex">
                {/* Vertical Hour Labels */}
                <div className="
                        tw-w-12 tw-flex-shrink-0 tw-bg-gray-50 tw-flex
                        tw-flex-col
                        tw-border-r tw-border-solid tw-border-border
                    "
                >
                    {HOURS.map(hour => (
                        <div
                            className="
                                    tw-flex tw-items-center tw-justify-center tw-text-[8px]
                                    tw-border-b tw-border-solid tw-border-border/30
                                    tw-flex-1
                                "
                            key={hour}
                        >
                            {`${String(hour).padStart(2, '0')}:00`}
                        </div>
                    ))}
                </div>

                {/* The Main Grid */}
                <div className="tw-flex tw-flex-grow">
                    {DAYS.map(day => (
                        <div className="tw-border-r tw-border-solid tw-border-border last:tw-border-r-0 tw-flex-1 tw-flex tw-flex-col" key={day}>
                            {HOURS.map(hour => (
                                <div className="tw-grid tw-grid-cols-4" key={`${day}-${hour}`}>
                                    {QUARTERS.map(qIndex => {
                                        const slotIndex = (hour * 4) + qIndex;
                                        const slotValue = schedule[day]?.[slotIndex];
                                        const paintOn = (slotValue && slotValue !== 'off' ? 'tw-bg-secondary' : ' tw-bg-transparent');

                                        return (
                                            <div
                                                className={`
                                                    tw-aspect-square
                                                    tw-relative
                                                    tw-border-r tw-border-b tw-border-solid tw-border-border/20
                                                    ${paintOn}
                                                `}
                                                key={qIndex}
                                                title={slotValue && slotValue !== 'off' ? `${hour}:${qIndex * 15} - ${slotValue}` : ''}
                                            />
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* Legend at Bottom */}
            <div className="tw-p-3 tw-bg-gray-50 tw-border-t tw-border-solid tw-border-border tw-flex tw-flex-wrap tw-gap-4">
                <div className="tw-flex tw-items-center tw-gap-1.5">
                    <div className={'tw-h-3 tw-w-3 tw-rounded-sm tw-border tw-border-black/10 tw-bg-secondary'}/>
                    <span className="tw-text-[10px] tw-font-semibold tw-text-gray-600">
                        {i18next.t('common.on').capitalize()} <span className="tw-font-normal tw-text-gray-400">({minValue}-{maxValue}) </span>
                    </span>
                </div>
            </div>
        </div>
    );
}
